import { Box, List, styled } from '@mui/material'
import Profile from './Profile'

export const AdminProfile = () => {
  return (
    <Box display="flex" flexGrow={1} justifyContent="flex-end" alignItems="center">
      <StyledList component="nav">
        <Profile />
      </StyledList>
    </Box>
  )
}

const StyledList = styled(List)<{ component?: React.ElementType }>(({ theme }) => ({
  padding: 0,
  '& .MuiListItemIcon-root': {
    minWidth: 32,
    color: theme.palette.grey[500],
  },
}))
